import backofficeService from '../../api/backoffice'

export default {
  getInvoiceById(id, params) {
    console.log('req.params.invoiceID', id)
    return backofficeService.Api().get(`api/invoice/${id.id}`, { params })
      .then(response => {
        return response.data
      })
      .catch((error) => { throw error })
  },
  getIpAddress(id) {
    return backofficeService.Api().get(`crm/api/store/ipAddress/${id}`)
      .then(response => {
        console.log('response', response)
        return response.data
      })
      .catch((error) => { throw error })
  },
}
